import { unmask } from './shared';
import { isNumericPostalCode } from './countries';
export function getValuesOrErrors(formElement, formValues) {
    var rawValues = {};
    var values = {};
    var errorElements = [];
    var hasRequiredError = false;
    if (formElement) {
        for (var key in formValues) {
            var name_1 = formValues[key].props.name || '';
            var unmask_1 = formValues[key].unmask;
            var element = formElement[name_1];
            if (element) {
                rawValues[key] = unmask_1 ? unmask_1(element.value) : element.value;
            }
        }
        for (var key in formValues) {
            var name_2 = formValues[key].props.name || '';
            var pattern = formValues[key].pattern;
            var unmask_2 = formValues[key].unmask;
            var blurError = formValues[key].blurError;
            var changeError = formValues[key].changeError;
            var element = formElement[name_2];
            if (element) {
                if (element.value) {
                    var value = unmask_2 ? unmask_2(element.value) : element.value;
                    values[key] = value;
                    if (pattern && !value.match(pattern)) {
                        errorElements.push(element);
                    }
                    if (blurError && blurError(value, formElement)) {
                        errorElements.push(element);
                    }
                    if (changeError && changeError(value, formElement)) {
                        errorElements.push(element);
                    }
                }
                else if (formValues[key].required) {
                    errorElements.push(element);
                    hasRequiredError = true;
                }
            }
        }
    }
    return { errorElements: errorElements, values: values, hasRequiredError: hasRequiredError };
}
export function handleKeydown(ev) {
    ev.target.oldValue = ev.target.value;
    ev.target.oldCursor = ev.target.selectionEnd;
}
export function handleValueChange(ev, formValues) {
    var element = ev.target;
    var name = element.name;
    var value = element.value;
    var values = formValues[name];
    var unmasked = values.unmask ? values.unmask(value) : value;
    if (values.pattern) {
        if (!('oldValue' in element)) {
            console.warn("Handle Keydown event not added, cursor position errors may arise for ".concat(name), element);
        }
        var match = unmasked.match(values.pattern);
        if (!match) {
            element.value = element.oldValue;
            setCursor(element, element.oldCursor);
            return;
        }
        if (values.mask) {
            element.value = values.mask(unmasked);
            if (values.getCursorPosition) {
                var newCursor = values.getCursorPosition(element);
                setCursor(element, newCursor);
            }
        }
    }
    removeError(element);
}
export function createFieldNameMap(formValuesArray) {
    var _a;
    var map = new Map();
    for (var _i = 0, formValuesArray_1 = formValuesArray; _i < formValuesArray_1.length; _i++) {
        var formValues = formValuesArray_1[_i];
        for (var key in formValues) {
            for (var _b = 0, _c = (_a = formValues[key].fieldNames) !== null && _a !== void 0 ? _a : []; _b < _c.length; _b++) {
                var fieldName = _c[_b];
                map.set(fieldName, key);
            }
        }
    }
    return map;
}
function setCursor(element, position) {
    if (typeof position === 'number') {
        element.setSelectionRange(position, position);
    }
}
export function addError(element) {
    element.setAttribute('error', 'true');
}
function removeError(element) {
    element.removeAttribute('error');
}
export var preventFormDefault = function (ev) {
    ev.preventDefault();
};
export function checkIfAutofilled(element) {
    try {
        var style = getComputedStyle(element);
        var mainColor = style.getPropertyValue('--background');
        var background = getComputedStyle(element)['background-color'];
        return mainColor && background !== mainColor;
        // return (
        //   element.matches(':autofill') ||
        //   element.matches(':-webkit-autofill') ||
        //   element.webkitMatchesSelector(':autofill') ||
        //   element.webkitMatchesSelector(':-webkit-autofill')
        // )
    }
    catch (err) {
        return false;
    }
}
export var focusNext = function (form, element) {
    var inputs = Array.from(form.querySelectorAll('input'));
    var nextIndex = inputs.indexOf(element) + 1;
    var input = inputs[nextIndex];
    if (nextIndex && input && input.focus) {
        try {
            input.scrollIntoView({ behavior: 'smooth' });
            input.focus();
        }
        catch (err) {
            var error = err;
            alert(error.message);
        }
    }
};
export var focusNextIfAutofilled = function (form, element) {
    var isAutofilled = checkIfAutofilled(element);
    if (form && isAutofilled) {
        focusNext(form, element);
    }
};
export var numericZipFields = {
    pattern: /^\d{0,5}$/g,
    blurError: function (value) {
        var unmasked = unmask(value);
        if (unmasked && unmasked.length < 5) {
            return 'Your postal code is incomplete.';
        }
        return '';
    },
    changeError: function () { return ''; },
};
export var alphanumericZipFields = {
    pattern: undefined,
    blurError: function () { return ''; },
    changeError: function () { return ''; },
};
export var numericZipProps = {
    inputMode: 'numeric',
};
export var alphanumericZipProps = {
    inputMode: 'none',
};
export function makeUpdateZipFields(values) {
    return function (ev) {
        var id = values.props.id;
        if (!id)
            return;
        var value = ev.target.value;
        var element = document.getElementById(id);
        var isNumeric = isNumericPostalCode(value);
        Object.assign(values, isNumeric ? numericZipFields : alphanumericZipFields);
        if (element) {
            var props = isNumeric ? numericZipProps : alphanumericZipProps;
            for (var key in props) {
                element.setAttribute(key, props[key]);
            }
            if (isNumeric) {
                element.value = unmask(element.value);
            }
        }
    };
}
//# sourceMappingURL=form.js.map